import reducer from './reducers';
import * as actions from './actions';
import sagas from './sagas';
import * as types from './types';

export const contentMetaActions = actions;
export const contentMetaSagas = sagas;
export const contentMetaReducer = reducer;
export const contentMetaTypes = types;
